module.exports = __webpack_public_path__ + "static/img/temp-profile-image.e10df2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp-profile-image.jpg
// module id = 06r/
// module chunks = 0